import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Phone, Mail, ArrowRight } from 'lucide-react';
import { Button } from './ui/button';

export const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { name: 'Home', path: '/' },
  ];

  return (
    <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white shadow-md' : 'bg-white/95 backdrop-blur-sm'
      }`}>
      <div className="bg-slate-800 text-white py-2">
        <div className="container mx-auto px-4 flex justify-between items-center text-sm">
          <div className="flex items-center gap-6">
            <a href="tel:02078343334" className="flex items-center gap-2 hover:text-blue-400 transition-colors">
              <Phone size={14} />
              <span className="hidden sm:inline"> 020 7834 3334</span>
            </a>
            <a href="mailto:info@bluewater-build.co.uk" className="flex items-center gap-2 hover:text-blue-400 transition-colors">
              <Mail size={14} />
              <span className="hidden sm:inline">info@bluewater-build.co.uk  </span>
            </a>
          </div>
          <div className="text-xs text-gray-300">
            Building Excellence Since 1998
          </div>
        </div>
      </div>

      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-20">
          <Link to="/" className="flex items-center gap-3 group">
            <div className="w-12 h-12 bg-gradient-to-br from-blue-600 to-blue-800 rounded-lg flex items-center justify-center shadow-lg group-hover:shadow-xl transition-shadow">
              <svg viewBox="0 0 24 24" className="w-7 h-7 text-white" fill="currentColor">
                <path d="M12 2L2 7v10c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V7l-10-5zm0 2.18l8 3.6v8.55c0 4.45-3.08 8.63-7 9.67-3.92-1.04-7-5.22-7-9.67V7.78l6-2.7V14h2V4.18z" />
              </svg>
            </div>
            <div className="flex flex-col">
              <span className="text-2xl font-bold text-slate-800 tracking-tight">BlueWater</span>
              <span className="text-xs text-blue-600 font-medium -mt-1">Construction Services</span>
            </div>
          </Link>

          <nav className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`text-sm font-medium transition-colors relative group ${location.pathname === link.path
                    ? 'text-blue-600'
                    : 'text-slate-700 hover:text-blue-600'
                  }`}
              >
                {link.name}
                <span className={`absolute -bottom-1 left-0 h-0.5 bg-blue-600 transition-all ${location.pathname === link.path ? 'w-full' : 'w-0 group-hover:w-full'
                  }`}></span>
              </Link>
            ))}
            <Button className=" flex flex-row bg-blue-600 hover:bg-blue-700 text-white shadow-md hover:shadow-lg transition-all">
              <Link to={'/contact'} className='flex items-center gap-2'>
                <p>Contact Us</p> <div><ArrowRight/></div>
              </Link>
            </Button>
          </nav>

          <button
            className="md:hidden p-2 text-slate-700 hover:text-blue-600 transition-colors"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {isMobileMenuOpen && (
        <div className="md:hidden bg-white border-t border-gray-200 shadow-lg">
          <nav className="container mx-auto px-4 py-4 flex flex-col gap-4">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`text-sm font-medium py-2 transition-colors ${location.pathname === link.path
                    ? 'text-blue-600'
                    : 'text-slate-700'
                  }`}
                onClick={() => setIsMobileMenuOpen(false)}
              >
                {link.name}
              </Link>
            ))}
            <Button className=" flex flex-row bg-blue-600 hover:bg-blue-700 text-white shadow-md hover:shadow-lg transition-all">
              <Link to={'/contact'} className='flex items-center gap-2'>
                <p>Contact Us</p> <div><ArrowRight/></div>
              </Link>
            </Button>
          </nav>
        </div>
      )}
    </header>
  );
};
